import CheckboxInput from "components/common/form/inputs/CheckboxInput";
import DateInput from "components/common/form/inputs/date/DateInput";
import Input from "components/common/form/inputs/Input";
import { DatalistFilterInputPropsType } from "types/datalist-types";

const DatalistFilterInput = <T, TFilter> (props: DatalistFilterInputPropsType<T, TFilter>) => {
    const type = props.column.filter!.type || props.column.type;
    const config = {
        name: props.name + props.column.name + "-value",
        placeholder: "data-list.filter.value",
        require: false,
        hideKeyboardButton: true
    }

    if (props.column.filter?.valueJSX?.length) {
        for (let index = 0; index < props.column.filter?.valueJSX?.length; index++) {
            if(props.column.filter.valueJSX[index].renderInput) {
                const element = props.column.filter!.valueJSX![index];
                if(element.conditionType.indexOf(props.value.condition!) > -1) {
                    return element.renderInput!(props, props.onChange);
                }
            }
        }
    }

    switch (type) {
        case 'nullDate':
        case 'date':
        case 'nullDateOnly':
        case 'dateOnly':
            return <DateInput 
                {...config} 
                value={props.value.value ? new Date(props.value.value) : undefined} 
                onChange={v => props.onChange(v as T)}
            />;
        case 'number':
        case 'nullNumber':
            return <Input type="number" {...config} value={props.value.value?.toString()} onChange={v => props.onChange(v as T)} />;
        case 'boolean':
            return <div className="my-auto px-24">
                <CheckboxInput {...config} value={props.value.value} onChange={v => props.onChange(v as T)} label="data-list.filter.value" />
            </div>;
        default: 
            return <Input type="text" {...config} value={props.value.value?.toString()} onChange={v => props.onChange(v as T)} />;
    }
};

export default DatalistFilterInput;
